import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Ability } from '@casl/ability';
import { Observable } from 'rxjs';

import { AbilityActions, AbilitySites } from '../../services';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentOverviewGuard implements CanActivate {
  constructor(private ability: Ability, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.ability.can(AbilityActions.read, AbilitySites.envoverview)) {
      return true;
    } else {
      // The user does not have the right to see this site, so forward him to our startpage
      // TODO: Perhaps we will forward him in the future to a "not authorized"-site?
      this.router.navigate(['/']);
      return false;
    }
  }
}
